import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(bookDetailPageLayout)/bookDetailLayout.js");
